import { KENO_NUMBER_STATUS, KenoNumber } from '../base/number'
import { RED_BALL_ATLAS_FRAMES, RED_BALL_TEXTURE_KEYS } from '.'
import { STANDARD_LARGE_NUMBER_RATIO } from '@Animation/constants'
import { ANIMATION_IDENTIFIERS } from '@Animation/types'

export class RedBallNumber extends KenoNumber {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    number: number,
    isPlayerSelected: boolean,
  ) {
    super(scene, x, y, number, isPlayerSelected, ANIMATION_IDENTIFIERS.RED_BALL)
  }

  getGlowAtlasFrame() {
    return RED_BALL_ATLAS_FRAMES.NUMBER_GLOW
  }

  getGlowAtlas() {
    return RED_BALL_TEXTURE_KEYS.ATLAS
  }

  createStatusTextureMap(): { [key in KENO_NUMBER_STATUS]: string } {
    return {
      [KENO_NUMBER_STATUS.DEFAULT]: RED_BALL_TEXTURE_KEYS.NUMBER_DEFAULT,
      [KENO_NUMBER_STATUS.SELECTED_PLAYER]: RED_BALL_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_SYSTEM]: RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_HIT]: RED_BALL_TEXTURE_KEYS.NUMBER_HIT,
    }
  }

  async numberPopAnimation(numberTexture: string, backgroundTexture: string | null) {
    this.tempBackground = backgroundTexture
      ? this.scene.add.image(0, 0, backgroundTexture, this.number - 1)
      : null

    this.tempBackground?.setOrigin(0.5, 0.5)

    this.tempNumber = this.scene.add.image(this.x, this.y, numberTexture, this.number - 1)
    this.tempNumber.setOrigin(0.5, 0.5)
    this.tempNumber.setScale(STANDARD_LARGE_NUMBER_RATIO)

    if (this.tempBackground) {
      this.add([this.tempBackground])
    }

    this.kenoScene.addToTopLayerNumberGridContainer(this.tempNumber)

    this.image.setVisible(false)

    await this.popEffect(this.tempNumber)

    this.tempBackground?.destroy()
    this.tempNumber.destroy()
    this.image.setVisible(true)
  }

  async skip() {
    this.tempNumber?.destroy()
    this.tempBackground?.destroy()
    await super.skip()
    this.tempBackground?.destroy()
    this.tempNumber?.destroy()
  }

  async transitionToSystemSelected(): Promise<void> {
    await this.numberPopAnimation(
      RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION_NUMBER,
      RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION_BACKGROUND,
    )
    super.transitionToSystemSelected()
  }

  async transitionToSelectedHit() {
    await this.numberPopAnimation(RED_BALL_TEXTURE_KEYS.NUMBER_HIT_TRANSITION, null)

    super.transitionToSelectedHit()
    this.setScale(1)
  }
}
